import { isMatch, parse } from 'date-fns';
import convertDateFormat from '../convertDateFormat';
export const possiblyMomentToDate = (value)=>{
    if (value && typeof value === 'object' && '_isAMomentObject' in value && typeof value.toDate === 'function') {
        return value.toDate();
    }
    if (value instanceof Date || value === undefined || value === null) {
        return value;
    }
    return value;
};
// Since date-fns consider date with two digit year to be valid despite yyyy format, check if format/value lengths equal
// https://github.com/date-fns/date-fns/issues/942#issuecomment-516808982
// Account for Ts escaped in convertDateFormat by removing 's in the length check
const validateDate = (value = '', format)=>{
    return isMatch(value, format) && value.length === format.replaceAll("'", '').length;
};
/**
 * Returns Date based on the specified format. If dateFormat is array, first matching format is used.
 * If the date is not valid, returns undefined.
 * @param {array || string} dateFormat
 * @param {string} value
 * @returns {Date|undefined} resolved date
 */ const resolveDateFromFormats = (dateFormat, value)=>{
    const resolvedValue = possiblyMomentToDate(value);
    if (resolvedValue instanceof Date) {
        return resolvedValue;
    }
    if (Array.isArray(dateFormat)) {
        const matchingFormats = dateFormat.filter((format)=>{
            const dateFnsFormat = convertDateFormat(format);
            return validateDate(resolvedValue, dateFnsFormat);
        });
        if (matchingFormats.length > 0) {
            const dateFnsFormat = convertDateFormat(matchingFormats[0]);
            return parse(resolvedValue, dateFnsFormat, new Date());
        }
    } else {
        const dateFnsFormat = convertDateFormat(dateFormat);
        if (validateDate(resolvedValue, dateFnsFormat)) {
            return parse(resolvedValue, dateFnsFormat, new Date());
        }
    }
};
export default resolveDateFromFormats;
